import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Seo, { trimMetaDescription } from '../components/Seo';
import founderImage from '../assets/founder.jpeg';
import drPurushottamImage from '../assets/dr-purushottam-naidu.jpeg';
import { getTeamMemberBySlug } from '../data/teamData';
import './TeamMember.css';

const TeamMember = () => {
  const { slug } = useParams();
  const member = getTeamMemberBySlug(slug);

  if (!member) {
    return (
      <div className="team-member-page">
        <div className="container">
          <p className="team-member-not-found">Team member not found.</p>
          <Link to="/about" className="team-member-back">Back to About</Link>
        </div>
      </div>
    );
  }

  const avatarImage = member.slug === 'ca-narasimhaswamy-basavani' ? founderImage : member.slug === 'dr-purushottam-naidu' ? drPurushottamImage : null;

  return (
    <div className="team-member-page">
      <Seo
        title={`${member.name} — InvFly Team`}
        description={trimMetaDescription(member.shortSummary || member.bio?.[0] || '')}
      />
      <section className="team-member-hero">
        <div className="hero-background-pattern" aria-hidden="true" />
        <div className="container">
          <Link to="/about" className="team-member-back-link">
            ← Back to Team
          </Link>
        </div>
      </section>

      <section className="team-member-content">
        <div className="container team-member-container">
          <article className="team-member-card">
            {member.isFounder && <span className="team-member-founder-badge">Founder</span>}
            <div className="team-member-header">
              <div className="team-member-avatar">
                {avatarImage ? (
                  <img src={avatarImage} alt={member.name} className="team-member-avatar-img" />
                ) : (
                  <span className="team-member-avatar-initials">{member.initials}</span>
                )}
              </div>
              <div className="team-member-heading">
                <h1 className="team-member-name">{member.name}</h1>
                <p className="team-member-title">{member.title}</p>
              </div>
            </div>

            <div className="team-member-bio">
              {member.bio.map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>

            <div className="team-member-expertise">
              <h2>Core Areas of Expertise</h2>
              <ul>
                {member.expertise.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="team-member-actions">
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="team-member-linkedin-btn"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                Connect on LinkedIn
              </a>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
};

export default TeamMember;
